import { activeOfferingFilterLabels } from './offeringSearch';
import type { SearchFilters } from './types';

const isSet = (value: unknown): boolean => {
  if (value == null || value === '') return false;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'object') {
    const option = value as { value?: unknown };
    return 'value' in option ? isSet(option.value) : true;
  }
  return true;
};

/** How many filters a search applied, for the "Filters (N)" button. Sort is not a filter. */
export const countAppliedFilters = (
  filters: SearchFilters | undefined,
  side: 'SEEKING' | 'OFFERING'
): number => {
  if (!filters) return 0;
  if (side === 'OFFERING') return activeOfferingFilterLabels(filters).length;
  return Object.entries(filters).filter(([key, value]) => key !== 'sortBy' && isSet(value)).length;
};
